<script setup lang="ts">
const props = defineProps({
  name: String,
  label: String,
  placeholder: String,
  value: String,
  disabled: Boolean,
  widthClass: String,
});

const model = defineModel<string | undefined>();
defineEmits<{
  (e: 'blur'): void;
}>();
</script>

<template>
  <div class="mb-2" :class="props.widthClass">
    <label :for="props.name" class="text-light-primary font-bold">{{ props.label }}</label>
    <div
      class="border-light-border dark:border-dark-brd-dark dark:bg-dark-list-bg flex h-12 w-full items-center rounded-md border"
    >
      <input
        :name="props.name"
        :id="props.name"
        type="text"
        class="text-light-primary dark:text-dark-primary box-border h-full w-full bg-transparent p-2 text-base outline-none"
        :placeholder="props.placeholder"
        autocomplete="off"
        v-model="model"
        :disabled="props.disabled"
        :data-test="`addresspart-${props.name}`"
        @blur="$emit('blur')"
      />
    </div>
  </div>
</template>
